import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthProvider.js';

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (value === null) {
    throw new Error('useAuth must be used inside <AuthProvider>');
  }
  return value;
}

/** True for an administrator acting as themselves. */
export function useCanAdminister(): boolean {
  return useAuth().canAdminister;
}

/** Shorthand for the many components that only need the API client. */
export function useApi(): AuthContextValue['api'] {
  return useAuth().api;
}
